import * as React from 'react';
import Tx from './Tx';
import { useState, useEffect } from 'react';

export default function Connecting(props) {
    const [timer, s_timer] = useState(props.timer || 20);

    useEffect(()=>{
        const interval = setInterval(()=>{
            if (timer === 1) {
                props.onDone && props.onDone();
                clearInterval(interval);
            }
            else {
                clearInterval(interval);
                s_timer(timer-1)
            }
        }, 1000);
    })

    return (
        <div><Tx>camera.connecting</Tx> {timer}</div>
        )
}